import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import iconSprite from '../../../assets/icon-sprite.svg';
import { fetchLoan } from '../../actions/p2p';

class LoanDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loan: [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { data } = this.props;
    if ((prevProps?.data?.id !== data?.id)) {
      // eslint-disable-next-line react/no-did-update-set-state
      if (!data?.id) this.setState({ loan: {} });
      else fetchLoan(data?.id).then(({ data: { loan } }) => this.setState({ loan }));
    }
  }

  render() {
    const { visible, onClose = function $() { } } = this.props;
    const { loan } = this.state;

    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="linkDetailsLabel">Loan Details</h5>
            <button type="button" className="close" onClick={onClose}>
              <svg width="48" height="48">
                <use xlinkHref={iconSprite + '#close-icon'}></use>
              </svg>
            </button>
          </div>
          <div className="modal-body">
            <div className="d-flex justify-content-between">
              <p>Principal</p>
              <span>
                ₦
                {Number(loan?.schedule?.principal).toLocaleString()}
              </span>
            </div>

            <div className="d-flex justify-content-between">
              <p>
                Interest
              </p>
              <span>
                ₦
                {Number(loan?.interest_due).toLocaleString()}
              </span>
            </div>
            <div className="d-flex justify-content-between">
              <p>
                Interest Rate
              </p>
              <span>
                {Number(loan?.interest_rate).toLocaleString()}%
              </span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Transaction Fee</p>
              <span>
                ₦
                {Number(loan?.transaction_fees).toLocaleString()}
              </span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Platform Deductions</p>
              <span>
                ₦
                {Number(loan?.platform_fees).toLocaleString()}
              </span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Your Earnings</p>
              <span>
                ₦
                {Number(+loan?.interest_due
                  - (+loan?.platform_fees + +loan?.transaction_fees)).toLocaleString()}
              </span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Amount Due</p>
              <span>
                ₦
                {Number(loan?.schedule?.amount_due).toLocaleString()}
              </span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Tenor</p>
              <span>
                {Number(loan?.tenor).toLocaleString()}
                {' '}
                {loan?.tenor_period}
              </span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Status</p>
              <span>{loan?.status?.status}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Application Date</p>
              <span>{moment(loan?.created_on).format('MMM DD, YYYY, h:mm:ss a')}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Date Disbursed</p>
              <span>{moment(loan?.disbursed_on).format('MMM DD, YYYY, h:mm:ss a')}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Purpose of Loan</p>
              <span>{loan?.loan_profile?.purpose}</span>
            </div>

          </div>

          <div className="modal-header">
            <h5 className="modal-title" id="linkDetailsLabel">Loan History</h5>
          </div>
          <div className="modal-body">
            {/* <div className="d-flex justify-content-between">
              <p>Paid Loans</p>
              <span>{loan?.type}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Bad Loans</p>
              <span>{loan?.type}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Loans Approved</p>
              <span>{loan?.type}</span>
            </div> */}
            {/* <div className="d-flex justify-content-between">
              <p>Value of Loans Approved</p>
              <span>{Number(loan?.amount).toLocaleString()}</span>
            </div> */}
            <div className="d-flex justify-content-between">
              <p>Date of Last Loan Approved</p>
              <span>{moment(loan?.created_on).format('MMM DD, YYYY, h:mm:ss a')}</span>
            </div>
            {/* <div className="d-flex justify-content-between">
              <p>Total Loan Requests</p>
              <span>{loan?.status}</span>
            </div> */}
            <div className="d-flex justify-content-between">
              <p>Borrower Since</p>
              <span>{moment(loan?.created_on).format('MMM DD, YYYY, h:mm:ss a')}</span>
            </div>

          </div>

          <div className="modal-header">
            <h5 className="modal-title" id="linkDetailsLabel">Personal Details</h5>
          </div>
          <div className="modal-body">
            <div className="d-flex justify-content-between">
              <p>Age</p>
              <span>{loan?.user?.age}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>City</p>
              <span>{loan?.user?.city}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>State</p>
              <span>{loan?.user?.state}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Address Verification Status</p>
              <span>{loan?.loan_profile?.address}</span>
            </div>
          </div>

          <div className="modal-header">
            <h5 className="modal-title" id="linkDetailsLabel">Employment Details</h5>
          </div>
          <div className="modal-body">
            <div className="d-flex justify-content-between">
              <p>Level of Education</p>
              <span>{loan?.borrower_profile?.educational_attainment}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Employment Status</p>
              <span>{loan?.borrower_profile?.employment_status}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Employment Date</p>
              <span>{loan?.borrower_profile?.work_start_date}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Sector of Employment</p>
              <span>{loan?.borrower_profile?.sector_of_employment}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Current Employer</p>
              <span>{loan?.borrower_profile?.current_employer}</span>
            </div>
            <div className="d-flex justify-content-between">
              <p>Monthly Income</p>
              <span>{loan?.borrower_profile?.monthly_net_income}</span>
            </div>
          </div>

          <div className="modal-header">
            <h5 className="modal-title" id="linkDetailsLabel">Guarantor</h5>
          </div>
          <div className="modal-body">
            <div className="d-flex justify-content-between">
              <p>Name</p>
              <span>
                {loan?.guarantor?.first_name}
                {' '}
                {loan?.guarantor?.last_name}
              </span>
            </div>
          </div>

        </div>
      </Modal>
    );
  }
}

export default LoanDetails;
